'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('custom-edit', {
      url: '/custom/:type/edit/:id',
      template: '<custom-edit></custom-edit>'
    });
}



// WEBPACK FOOTER //
// ./client/app/custom/edit/custom-edit.routes.js